import NewEmail from './newEmail';


export default NewEmail;




// WEBPACK FOOTER //
// ./src/views/email/newEmail/container/index.js